import React from "react";
import "./CartItem.css"; // Assuming you have CSS for styling the cart item

const CartItem = ({ item, onDelete }) => {
  // console.log("item", item);
  return (
    <div className="cart-item">
      <div className="item-details">
        <h4>{item?.product?.name}</h4>
      </div>
      <div className="item-actions">
        <p>
          Price: ₦
          {(
            item?.product?.sale_price ??
            item?.product?.price ??
            item?.product?.auction_highest_bid
          )?.toLocaleString()}
        </p>
        <button className="delete-btn" onClick={onDelete}>
          Delete
        </button>
      </div>
    </div>
  );
};

export default CartItem;
